import {
  baseMaps,
  clearBaseMapForMap,
  getCurrentBaseMaps,
  setBaseMapForMap,
  setBaseMaps,
} from '../../store/store-baseMap'

export default {
  props: {
    mapId: String,
    title: {
      type: String,
      default: 'Bản đồ nền',
    },
  },
  inject: {
    i_mapId: {
      from: /* injection key */ 'mapId',
      default: null,
    },
  },
  computed: {
    c_mapId() {
      return this.i_mapId || this.mapId
    },
    c_baseMaps() {
      return baseMaps(this.c_mapId)
    },
    current_baseMaps: {
      get() {
        return getCurrentBaseMaps(this.c_mapId)
      },
    },
  },
  methods: {
    onDestroy() {
      this.clear()
    },
    setBaseMaps(baseMaps) {
      setBaseMaps(this.c_mapId, baseMaps)
    },

    clear() {
      clearBaseMapForMap(this.c_mapId)
    },
    loadItem(item) {
      setBaseMapForMap(this.c_mapId, item)
    },
  },
}
